import { httpFailed } from '@ibkr/clientportal.common/src/js/http'
import * as types from '../mutation-types'
import ibcust from '../../api/ibcustApi'

const state = {
    /* store all the services market data subscribed to */
    marketDataSubscriptions: [],
    entityInfo: []
}

const getters = {
    entityInfo: state =>{
        return state.entityInfo || [];
    },

    entityInfoAddresses: state => {
        const ret = [];
        state.entityInfo && state.entityInfo.forEach(applicant => {
            applicant.entities.forEach(entity => {
                ret.push(entity.address || {});
            });
        });
        return ret;
    },
    entityInfoNames: state => {
        const ret = [];
        state.entityInfo && state.entityInfo.forEach(applicant => {
            applicant.entities.forEach(entity => {
                const name = entity.name || {};
                ret.push(name.firstName + ' '  + name.lastName);
            });
        });
        return ret;
    },
    entityInfoIdentDocs: state => {
        let ret = [];
        state.entityInfo && state.entityInfo.forEach(applicant => {
            applicant.entities.forEach(entity => {
                if (entity.identDocs) {
                    ret = ret.concat(entity.identDocs);
                }
            });
        });
        return ret;
    },
    CUSIPSubscribed: state => {
        return state.marketDataSubscriptions.length > 0 && (state.marketDataSubscriptions.indexOf(550) != -1
                || state.marketDataSubscriptions.indexOf(551) != -1);
    }
}

const mutations = {
    [types.SET_ENTITY_INFO] : (state, info) => {
        state.entityInfo = info || [];
    },
    [types.SET_MARKETDATA_SUBSCRIPTIONS] : (state, data) => {
        state.marketDataSubscriptions = data;
    }
}

const actions = {

    getEntityInfo({ commit, dispatch, state }, { onSuccess, onError }) {
        ibcust.getEntityInfo()
            .then((res) => {
                commit(types.SET_ENTITY_INFO, res);
            }).catch((result) => {
                if (onError) onError(result);
                httpFailed('get entity info', commit, result);
            })
    },

    getMarketDataSubscriptions({ commit, dispatch, state }, { onSuccess, onError }) {
        ibcust.getMarketDataSubscriptions()
            .then((res) => {
                commit(types.SET_MARKETDATA_SUBSCRIPTIONS, res);
            })
            .catch((result) => {
                if (onError) onError(result);
                httpFailed("get market data subscription", commit, result);
            });
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

